import { render, staticRenderFns } from "./standardActions.vue?vue&type=template&id=3503b225&"
import script from "./standardActions.vue?vue&type=script&lang=js&"
export * from "./standardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports